<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="直播批次" prop="liveBatchName">
          <el-select v-model="searchForm.liveBatchName" filterable multiple collapse-tags clearable @change="categoryDetailChange">
            <el-option v-show="!all2" label="全部" value=""></el-option>
            <el-option v-show="all2" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in liveBatchNameList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺" prop="storeName">
          <el-select v-model="searchForm.storeName" filterable multiple collapse-tags clearable @change="storeChange">
            <el-option v-show="!all" label="全部" value=""></el-option>
            <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in storeNameList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品编码" prop="goodsCode">
          <el-input v-model="searchForm.goodsCode" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model.trim="searchForm.goodsName" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="text-align: right">
          <el-button type="primary" size="mini" @click="$router.push({name: 'LiveOrderDetails'})">订单明细</el-button>
          <el-button type="danger" size="mini" :disabled="!multipleSelection.length" @click="delList">删除</el-button>
          <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
          <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
        </div>
        <div style="padding-top: 10px; text-align: right" v-if="isShowText">预估量{{textNum.planAmount}}，实销量{{textNum.actualSaleNum}}</div>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.records"
        :height="maxTableHeight"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
        :row-key="(row) => row.dataId"
        v-if="tableReload"
        v-loading="loading"
      >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.displayName == '图片'">
              <el-button type="text" @click="imgShow(scope.row)" v-if="scope.row.photoUrls">查看</el-button>
            </template>
            <template v-else>
              {{ scope.row[item.columnName] | cellValFormat }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <el-dialog title="查看图片" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </div>
</template>

<script>
import imgShow from "@/views/components/imgShow.vue";
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import axios from "@/utils/axiosInstance";
import moment from "moment";
export default {
  name: "jobDataAnalysis",
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "prePlanLiveOrderGoodsInfo",
      columnData: [],
      storeList: [],
      categoryDetailList: [],
      loading: false,
      searchForm: {
        liveBatchName: [],
        storeName: [],
        goodsCode: "",
        goodsName: "",
      },
      exportData: {},
      orderSort: {},
      searchCollapse: false,
      all: false,
      all2: false,
      defaultStroe: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      imgList: [],
      storeNameList: [],
      liveBatchNameList: [],
      multipleSelection: [],
      storeNameList: [],
      dialogFormVisible: false,
      textNum: {
        actualSaleNum: 0,
        planAmount: 0,
      }
    };
  },
  computed: {
    isShowText() {
      let searchForm = this.searchFormData.filterData || {};
      return (searchForm.goodsCode && searchForm.goodsCode.length == 1) || searchForm.goodsName;
    },
  },
  watch: {
    isShowText(val, old) {
      if(val) {
        this.onSearchSum()
      }
      this.addListener();
      this.setMaxHeight();
      this.$bus.$on("table.updateHeight", (offset) => {
        this.setMaxHeight(offset || 0);
      });
    },
  },
  mounted() {
    this.columns();
    this.getLiveBatchName();
    this.getStoreName();
  },
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.onSearch();
      });
    },
    onSearchSum() {
      let { goodsCode, goodsName } = this.searchForm
      let data = {...this.currencyForm}
      data.reportCode = "prePlanLiveOrderGoodsInfoSum"
      data.param = {
        goodsCode: goodsCode,
        goodsName: goodsName
      }
      axios
        .post(`/ec-pc-api/custom/reports/data/prePlanLiveOrderGoodsInfoSum`, data)
        .then((res) => {
          if (res.code == 200) {
            this.textNum = {
              actualSaleNum: res.data.list[0].actualSaleNum || 0,
              planAmount: res.data.list[0].planAmount || 0,
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.orderSort = {};
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          goodsCode: this.searchForm.goodsCode ? this.searchForm.goodsCode.split(" ") : [],
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.searchFormData = data.filterData;
      this.$q.preSalePlan
        .planLiveOrderListPage({ data: data })
        .then((res) => {
          console.log(res.data);
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.all = false;
      this.all2 = false;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    storeChange(val) {
      this.all = this.storeNameList.length == val.length;
      if (val.includes("")) {
        this.searchForm.storeName = this.storeNameList;
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.storeName = [];
        this.all = false;
      }
    },
    categoryDetailChange(val) {
      this.all2 = this.liveBatchNameList.length == val.length;
      if (val.includes("")) {
        this.searchForm.liveBatchName = this.liveBatchNameList;
        this.all2 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.liveBatchName = [];
        this.all2 = false;
      }
    },
    //直播批次
    getLiveBatchName() {
      let data = { ...this.currencyForm };
      data.reportCode = 'prePlanLiveOrderGoodsInfo';
      data.groupAttr = "liveBatchName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.liveBatchNameList = data;
      });
    },
    //店铺
    getStoreName() {
      let data = { ...this.currencyForm };
      data.reportCode = 'prePlanLiveOrderGoodsInfo';
      data.groupAttr = "storeName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeNameList = data;
      });
    },

    imgShow(row) {
      this.imgList = row.photos;
      this.dialogFormVisible = true;
    },

    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.orderSort = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.init();
    },
    async delList() {
      let status = await this.$confirm("是否确认删除？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      let data = this.multipleSelection.map((v) => v.dataId);
      this.$q.preSalePlan.planLiveOrderDelete({ data: data }).then((res) => {
        if (res.success) {
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.message);
        }
        this.onSearch();
      });
    },
    importExcel() {
      this.$router.push({
        path: "/order/orderDistribution/LiveBroadcastSkuImport",
        query: {
          fileName: "预销计划-直播-商品导入.xlsx",
          appCode: "ec-pc-new",
        },
      });
    },
    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  beforeDestroy() {
    this.$emit('searchForm',{...this.searchForm,all: this.all, all2: this.all2})
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .search-outer>div
  padding 0
>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
